/**
 * Order of the New Daily Assignments queue: the soonest move first, then the
 * largest cubic feet, then the highest price.
 */

const cubicFeet = (job) =>
  parseInt(String(job.totalCubicFeet || "").replace(/[^0-9]/g, ""), 10) || 0;

export const byUrgencyThenSize = (jobs) =>
  [...(jobs || [])].sort(
    (a, b) =>
      String(a.moveDate).localeCompare(String(b.moveDate)) ||
      cubicFeet(b) - cubicFeet(a) ||
      (Number(b.price) || 0) - (Number(a.price) || 0),
  );
